import {
  PRODUCT_IMAGE_LIST_REQUEST,
  PRODUCT_IMAGE_LIST_SUCCESS,
  PRODUCT_IMAGE_LIST_FAIL,
  PRODUCT_IMAGE_DETAILS_REQUEST,
  PRODUCT_IMAGE_DETAILS_SUCCESS,
  PRODUCT_IMAGE_DETAILS_FAIL,
  PRODUCT_IMAGE_DELETE_REQUEST,
  PRODUCT_IMAGE_DELETE_SUCCESS,
  PRODUCT_IMAGE_DELETE_FAIL,
  PRODUCT_IMAGE_CREATE_RESET,
  PRODUCT_IMAGE_CREATE_FAIL,
  PRODUCT_IMAGE_CREATE_SUCCESS,
  PRODUCT_IMAGE_CREATE_REQUEST,
  PRODUCT_IMAGE_UPDATE_REQUEST,
  PRODUCT_IMAGE_UPDATE_SUCCESS,
  PRODUCT_IMAGE_UPDATE_FAIL,
  PRODUCT_IMAGE_UPDATE_RESET,
} from "../constants/productImageConstants";

export const productImageListReducer = (
  state = { productImages: [] },
  action
) => {
  switch (action.type) {
    case PRODUCT_IMAGE_LIST_REQUEST:
      return { loading: true, productImages: [] };
    case PRODUCT_IMAGE_LIST_SUCCESS:
      return {
        loading: false,
        productImages: action.payload.productImages,
        pages: action.payload.pages,
        page: action.payload.page,
      };
    case PRODUCT_IMAGE_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const productImageDetailsReducer = (
  state = { productImage: { reviews: [] } },
  action
) => {
  switch (action.type) {
    case PRODUCT_IMAGE_DETAILS_REQUEST:
      return { ...state, loading: true };
    case PRODUCT_IMAGE_DETAILS_SUCCESS:
      return { loading: false, productImage: action.payload };
    case PRODUCT_IMAGE_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const productImageDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case PRODUCT_IMAGE_DELETE_REQUEST:
      return { loading: true };
    case PRODUCT_IMAGE_DELETE_SUCCESS:
      return { loading: false, success: true };
    case PRODUCT_IMAGE_DELETE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const productImageCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case PRODUCT_IMAGE_CREATE_REQUEST:
      return { loading: true };
    case PRODUCT_IMAGE_CREATE_SUCCESS:
      return { loading: false, success: true, productImage: action.payload };
    case PRODUCT_IMAGE_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case PRODUCT_IMAGE_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

export const productImageUpdateReducer = (
  state = { productImage: {} },
  action
) => {
  switch (action.type) {
    case PRODUCT_IMAGE_UPDATE_REQUEST:
      return { loading: true };
    case PRODUCT_IMAGE_UPDATE_SUCCESS:
      return { loading: false, success: true, productImage: action.payload };
    case PRODUCT_IMAGE_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case PRODUCT_IMAGE_UPDATE_RESET:
      return { productImage: {} };
    default:
      return state;
  }
};
